(function(){
function isNl(){return location.pathname.indexOf('/nl/')===0||location.pathname==='/nl'||/^nl/i.test(document.documentElement.lang||'');}
function init(root){
if(root.dataset.pvDesignerBriefReady)return;
root.dataset.pvDesignerBriefReady='1';
var services=root.querySelector('.pv-order__services');
var first=root.querySelector('[data-pv-design-service]');
var formId=first&&first.getAttribute('form');
if(!services||!formId)return;
var nl=isNl();
var block=document.createElement('div');
block.className='pv-order__designer-brief';
block.setAttribute('data-pv-designer-brief','');
block.hidden=true;
block.innerHTML='<label class="pv-order__label">'+(nl?'Designer instructies':'Designer instructions')+'</label><textarea name="properties[Designer instructies]" placeholder="'+(nl?'Logo-positie, tekst, kleuren, deadline, voorbeelden.':'Logo position, copy, colours, deadline, examples.')+'" disabled></textarea><span class="pv-order__small">'+(nl?'Upload extra logo\'s, huisstijl of voorbeelden.':'Upload extra logos, brand files or examples.')+'</span><div class="pv-order__designer-files"><input type="file" name="properties[Extra bestand 1]" disabled><input type="file" name="properties[Extra bestand 2]" disabled></div>';
block.querySelectorAll('textarea,input').forEach(function(el){el.setAttribute('form',formId);});
services.appendChild(block);
function sync(){
var checked=root.querySelector('[data-pv-design-service]:checked');
var label=String((checked&&(checked.getAttribute('data-label')||checked.value))||'').toLowerCase();
var show=label.indexOf('laat je ontwerp maken of aanpassen')!==-1||label.indexOf('have your design created or adjusted')!==-1||label.indexOf('make or edit your design')!==-1||label.indexOf('design made or adjusted')!==-1;
block.hidden=!show;
block.querySelectorAll('textarea,input').forEach(function(el){el.disabled=!show;});
}
root.querySelectorAll('[data-pv-design-service]').forEach(function(input){input.addEventListener('change',sync);});
sync();
}

/* Per-size minimum quantity and tier dots (added 2026-10-26).
   Sizes in promo_vista.size_options may start at a higher tier than the first size
   (e.g. LED cube 25-50 cm from 6 pcs). The base configurator reads one minimum for the
   whole product; this keeps the quantity input, its note and the tier dots in line with
   the selected size. Products whose sizes share the same tiers are unaffected. */
function initSizeRules(root){
if(root.dataset.pvSizeRulesReady)return;
root.dataset.pvSizeRulesReady='1';
var sizeJson=root.querySelector('[data-pv-size-json]');
var qty=root.querySelector('[data-pv-quantity]');
if(!sizeJson||!qty)return;
var sizes;
try{sizes=JSON.parse(sizeJson.textContent||'[]');}catch(e){return;}
if(!sizes||!sizes.length)return;
var inputs=root.querySelectorAll('[data-pv-size-input]');
var dots=root.querySelectorAll('[data-pv-tier-dot]');
var nl=isNl();
var note=document.createElement('span');
note.className='pv-order__small';
note.setAttribute('data-pv-min-note','');
note.hidden=true;
qty.insertAdjacentElement('afterend',note);
function active(){
var sel=null;
inputs.forEach(function(i){if(i.checked)sel=i.value;});
for(var k=0;k<sizes.length;k++){if(sizes[k].label===sel)return sizes[k];}
return sizes[0];
}
function apply(){
var s=active();
var tiers=(s&&s.tiers)||[];
if(!tiers.length)return;
var min=tiers.reduce(function(m,t){var v=Number(t.min)||1;return v<m?v:m;},Infinity);
qty.setAttribute('min',min);
var labels=tiers.map(function(t){return t.label;});
dots.forEach(function(d){d.style.display=labels.indexOf(d.getAttribute('data-label'))===-1?'none':'';});
note.hidden=min<=1;
note.textContent=nl?('Minimaal '+min+' stuks voor '+s.label):('Minimum '+min+' pieces for '+s.label);
var v=parseInt(qty.value,10);
if(!isFinite(v)||v<min){
qty.value=min;
qty.dispatchEvent(new Event('change',{bubbles:true}));
}
}
inputs.forEach(function(i){i.addEventListener('change',function(){setTimeout(apply,0);});});
qty.addEventListener('change',function(){
var min=Number(qty.getAttribute('min'))||1;
var v=parseInt(qty.value,10);
if(isFinite(v)&&v<min){qty.value=min;qty.dispatchEvent(new Event('change',{bubbles:true}));}
});
apply();
}

/* Product-specific print method (added 2026-10-26).
   The base configurator sends "Full color sublimation print" for every product. A product
   can override it by adding this marker to its description:
   <span data-pv-print-method="EN text" data-pv-print-method-nl="NL text" hidden></span> */
function initPrintMethod(root){
var src=document.querySelector('[data-pv-print-method]');
if(!src)return;
var val=isNl()?(src.getAttribute('data-pv-print-method-nl')||src.getAttribute('data-pv-print-method')):src.getAttribute('data-pv-print-method');
if(!val)return;
var first=root.querySelector('[data-pv-quantity]');
var formId=first&&first.getAttribute('form');
var sel='input[type="hidden"][name="properties[Bedrukking]"],input[type="hidden"][name="properties[Print method]"]';
document.querySelectorAll(sel).forEach(function(el){
if(!formId||el.getAttribute('form')===formId)el.value=val;
});
}

/* Quote-only sizes (added 2026-10-26).
   A size in promo_vista.size_options without pricing_tiers is shown as a size card marked
   "on request". Selecting it hides quantity, price, upload and checkout, and shows a quote
   request link instead. Products without such sizes are unaffected. */
function initQuoteSizes(root){
if(root.dataset.pvQuoteSizesReady)return;
root.dataset.pvQuoteSizesReady='1';
var sizeJson=root.querySelector('[data-pv-size-json]');
if(!sizeJson)return;
var sizes;
try{sizes=JSON.parse(sizeJson.textContent||'[]');}catch(e){return;}
var quote={};
(sizes||[]).forEach(function(s){if(!s.tiers||!s.tiers.length)quote[s.label]=true;});
if(!Object.keys(quote).length)return;
var nl=isNl();
if(!document.getElementById('pv-quote-size-style')){
var st=document.createElement('style');
st.id='pv-quote-size-style';
st.textContent='.pv-quote-mode .pv-order__quantity-row,.pv-quote-mode .pv-order__tiers,.pv-quote-mode .pv-order__artwork,.pv-quote-mode .pv-order__fields,.pv-quote-mode .pv-order__label:has(+.pv-order__fields),.pv-quote-mode .pv-order__services,.pv-quote-mode .pv-order__checkout,.pv-quote-mode .pv-order__checkout+.pv-order__small,.pv-quote-mode [data-pv-production-time],.pv-quote-mode [data-pv-delivery-time]{display:none!important}.pv-order__quote-size{margin:16px 0;padding:16px;border:1px solid currentColor;border-radius:8px}.pv-order__quote-size p{margin:0 0 12px}.pv-order__quote-size .pv-order__checkout{display:inline-block!important;text-decoration:none;text-align:center}';
document.head.appendChild(st);
}
var inputs=root.querySelectorAll('[data-pv-size-input]');
inputs.forEach(function(i){
if(!quote[i.value])return;
var card=i.closest('[data-pv-size-card]');
var price=card&&card.querySelector('.pv-order__size-price');
if(price)price.textContent=nl?'Op aanvraag':'On request';
});
var panel=document.createElement('div');
panel.className='pv-order__quote-size';
panel.hidden=true;
var sizesBlock=root.querySelector('.pv-order__sizes');
if(sizesBlock)sizesBlock.insertAdjacentElement('afterend',panel);else root.insertBefore(panel,root.firstChild);
var qty=root.querySelector('[data-pv-quantity]');
var formId=qty&&qty.getAttribute('form');
var checkout=root.querySelector('.pv-order__checkout');
function apply(){
var sel=null;
inputs.forEach(function(i){if(i.checked)sel=i.value;});
var on=!!quote[sel];
root.classList.toggle('pv-quote-mode',on);
panel.hidden=!on;
if(checkout)checkout.disabled=on;
var form=formId&&document.getElementById(formId);
var vid=form&&form.querySelector('input[name="id"]');
if(vid)vid.disabled=on;
if(on){
var url=(nl?'/nl':'')+'/pages/custom-quote-request';
var title=(document.querySelector('h1')||{}).textContent||'';
panel.innerHTML='<strong>'+(nl?(sel+' maken we op aanvraag'):(sel+' is made on request'))+'</strong><p>'+(nl?'Dit formaat wordt per project geproduceerd en verzonden. Vraag een offerte aan met je aantal en deadline, dan sturen we je prijs en levertijd.':'This size is produced and shipped per project. Request a quote with your quantity and deadline and we will send you price and lead time.')+'</p><a class="pv-order__checkout" href="'+url+'?product='+encodeURIComponent(title.trim())+'&size='+encodeURIComponent(sel)+'">'+(nl?'Offerte aanvragen':'Request a quote')+'</a>';
}
}
inputs.forEach(function(i){i.addEventListener('change',function(){setTimeout(apply,0);});});
if(checkout)checkout.addEventListener('click',function(e){if(root.classList.contains('pv-quote-mode'))e.preventDefault();});
apply();
}

function boot(){
document.querySelectorAll('.promo-vista-order-configurator').forEach(function(root){
init(root);
initSizeRules(root);
initPrintMethod(root);
initQuoteSizes(root);
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
